import { useEffect } from "react";

function SiteBackdrop() {
  useEffect(() => {
    let frame = 0;

    const updatePointer = (event) => {
      if (frame) {
        return;
      }

      frame = window.requestAnimationFrame(() => {
        document.documentElement.style.setProperty("--pointer-x", `${event.clientX}px`);
        document.documentElement.style.setProperty("--pointer-y", `${event.clientY}px`);
        frame = 0;
      });
    };

    document.documentElement.style.setProperty("--pointer-x", "50vw");
    document.documentElement.style.setProperty("--pointer-y", "35vh");
    window.addEventListener("pointermove", updatePointer, { passive: true });

    return () => {
      if (frame) {
        window.cancelAnimationFrame(frame);
      }

      window.removeEventListener("pointermove", updatePointer);
    };
  }, []);

  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden bg-mist transition-colors duration-500 dark:bg-outerspace"
      aria-hidden="true"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_var(--pointer-x)_var(--pointer-y),rgba(200,168,81,0.16),transparent_22rem),linear-gradient(110deg,rgba(239,245,243,0.98)_0%,rgba(255,255,255,0.92)_42%,rgba(200,168,81,0.16)_100%)] dark:bg-[radial-gradient(ellipse_at_var(--pointer-x)_var(--pointer-y),rgba(200,168,81,0.12),transparent_24rem),linear-gradient(130deg,#0e1b2b_0%,#172335_56%,#0e1b2b_100%)]" />
      <div className="absolute inset-0 opacity-[0.26] mix-blend-multiply dark:opacity-[0.2] dark:mix-blend-screen">
        <div className="absolute inset-[-12rem] animate-[cc-soft-pan_36s_linear_infinite] bg-[linear-gradient(rgba(14,27,43,0.10)_1px,transparent_1px),linear-gradient(90deg,rgba(14,27,43,0.10)_1px,transparent_1px)] bg-[length:9.5rem_9.5rem] dark:bg-[linear-gradient(rgba(200,168,81,0.11)_1px,transparent_1px),linear-gradient(90deg,rgba(200,168,81,0.11)_1px,transparent_1px)]" />
      </div>
      <div className="absolute inset-x-0 top-0 h-[42rem] bg-[linear-gradient(180deg,rgba(255,255,255,0.8),rgba(255,255,255,0))] dark:bg-[linear-gradient(180deg,rgba(14,27,43,0.85),rgba(14,27,43,0))]" />
      <div className="absolute inset-x-0 bottom-0 h-[36rem] bg-[linear-gradient(0deg,rgba(200,168,81,0.1),rgba(200,168,81,0))] dark:bg-[linear-gradient(0deg,rgba(0,0,0,0.18),rgba(0,0,0,0))]" />
      <div className="absolute inset-0 opacity-[0.06] [background-image:radial-gradient(circle_at_center,rgba(14,27,43,0.9)_0.5px,transparent_0.5px)] [background-size:4px_4px] dark:opacity-[0.08] dark:[background-image:radial-gradient(circle_at_center,rgba(255,255,255,0.9)_0.5px,transparent_0.5px)]" />
    </div>
  );
}

export default SiteBackdrop;
